import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {singularizeCamelCase} from '../../../utils/utils';

interface ExplorerHeaderProps {
    label: string;
    exploreMode: boolean;
    showNewButton: boolean;
    newButtonDisabled: boolean;
    onClickNew: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * Header component for the Explorer containing title and New button
 */
export const ExplorerHeader: React.FC<ExplorerHeaderProps> = ({
    label,
    exploreMode,
    showNewButton,
    newButtonDisabled,
    onClickNew
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 0.5, pr: 0 }}>
            <Typography variant='h6' color='primary' gutterBottom>{label}</Typography>
            {exploreMode && showNewButton && (
                <Button
                    variant='contained'
                    title={`New ${singularizeCamelCase(label)}`}
                    size='small'
                    component='button'
                    onClick={onClickNew}
                    startIcon={<AddIcon />}
                    disabled={newButtonDisabled}
                >
                    New
                </Button>
            )}
        </Box>
    );
};